import { Form, FormFieldOptions, FormResponseValue } from "@tellescope/types-models";
import { responsesSatisfyConditions } from "../../utils";

export interface ProductVisibilityContext {
  options: FormFieldOptions;
  formResponses: FormResponseValue[];
  form: Form;
  dateOfBirth?: string;
  gender?: string;
  state?: string;
}

/**
 * Whether a product passes its `productConditions.showCondition`. A product with no
 * configured condition is always visible. Selections must be filtered through this —
 * a product hidden by a condition must not be charged for.
 */
export const productIsVisible = (
  productId: string,
  { options, formResponses, form, dateOfBirth, gender, state }: ProductVisibilityContext
) => {
  const productCondition = options.productConditions?.find((condition) => condition.productId === productId);

  if (productCondition?.showCondition === undefined || !Object.keys(productCondition.showCondition).length) {
    return true;
  }

  return responsesSatisfyConditions(formResponses, productCondition.showCondition, {
    dateOfBirth,
    gender,
    state,
    form,
    activeResponses: formResponses,
  });
};
